module.exports = __webpack_public_path__ + "54e9bab5fdd6cec86968293a65ab0117.png";